import axios from 'axios';

async function sendMessage(params) {
  return await axios.post('http://gb365.co.kr:3001/send', params, {
    headers: { 'Content-Type': `application/json` },
  });
}

export { sendMessage };
